module.exports = __webpack_public_path__ + "img/charles yates, 1958 (1).ad35187c.jpg";